<template>
    <div class="container table-data">
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="学校名称">
                <el-autocomplete
                    v-model="autocompleteData.school_name"
                    clearable
                    value-key="school_name"
                    placeholder="请输入学校"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'schoolsList')"
                    @clear="clearSelect('schoolsList', 2)"
                    @select="(item)=>handleSelect(item, 'schoolsList')">
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="门店名称" prop="shopCode">
                <el-autocomplete
                    v-model="autocompleteData.shop_name"
                    clearable
                    value-key="shop_name"
                    placeholder="请输入门店"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'shopsList')"
                    @clear="clearSelect('shopsList')"
                    @select="(item)=>handleSelect(item, 'shopsList')">
                </el-autocomplete>
            </el-form-item>

            <el-form-item label="商品名称" prop="goodCode">
                <el-autocomplete
                    v-model="autocompleteData.good_name"
                    clearable
                    value-key="gdName"
                    placeholder="请输入商品"
                    :trigger-on-focus="false"
                    :fetch-suggestions="(query, cb) => querySchoolSearch(query, cb, 'goodsList')"
                    @clear="clearSelect('goodsList')"
                    @select="(item)=>handleSelect(item, 'goodsList')">
                </el-autocomplete>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                v-for="(item, index) in tableColumn"
                :prop="item.id"
                :label="item.name"
                :show-overflow-tooltip="true"
                :key="index"
                :width="item.width"
                :fixed="item.fixed">
                <template slot-scope="scope">
                    <span v-if="item.formatter">{{ item.formatter(scope.row) }}</span>
                    <span v-else>{{ scope.row[item.id] }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNo"
            :page-sizes="pageSizes"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { getSchoolAndShop } from '~/mixins/getSchoolAndShop'

export default {
    name: "goodsList",
    data () {
        return {
            queryFormLabelWidth: '90px', // 自定义查询表单label宽度
            queryForm: {
                pageSize: 10,
                pageNo: 1,
            },
            loading: false,
            tableColumn: [
                { name: '学校名称', id: 'schoolName', fixed: false, },
                { name: '门店名称', id: 'shopName', fixed: false, },
                { name: '商品名称', id: 'gdName', fixed: false, },
                { name: '商品库存', id: 'saleableStock', width: '150', fixed: false, },
                {
                    name: '状态',
                    id: 'display',
                    fixed: false,
                    formatter: function (row) {
                        return row.display == 1 ? '上架' : '下架';
                    }
                },
                { name: '销量', id: 'saleNum', width: '150', fixed: false, },
            ],
            tableData: [],
            total: 0,
            pageSizes: [10,20,30,40,50], // 自定义分页条数
        }
    },
    mixins: [ getSchoolAndShop, ],
    methods: {
        /** 切换每页显示条数操作 */
        handleSizeChange(val) {
            this.queryForm.pageSize = val;
            this.fetchData();
        },
        /** 切换页码操作 */
        handleCurrentChange(val) {
            this.queryForm.pageNo = val;
            this.fetchData();
        },
        /** 获取数据 */
        fetchData () {
            this.loading = true;
            let params = {};
            params.schoolCode = this.autocompleteData.school_id; //	学校名称
            params.shopCode = this.autocompleteData.shop_id; // 门店名称
            params.goodName = this.autocompleteData.good_name; // 商品名称
            params.pageNo = this.queryForm.pageNo - 1;
            params.pageSize = this.queryForm.pageSize;
            this.$apiJava.post(this.$apiUrl.commercialGoodsList, params,(res)=>{
                if (res.message == "success" && res.result) {
                    this.tableData = res.data;
                    this.total = res.data.length ? res.data[0].total : 0;
                } else {
                    this.$message.warning(res.message);
                    this.tableData = [];
                    this.total = 0;
                }
                this.loading = false;
            },(res)=>{
                this.loading = false;
                this.tableData = [];
                this.total = 0;
            },'gc')
        },
        /** 重置 */
        resetForm () {
            this.queryForm.pageSize = 10;
            this.queryForm.pageNo = 1;
            this.clearSelect('schoolsList');
            this.fetchData();
        },
    },
    created() {
        // this.fetchData();
    },
    mounted () {
        this.fetchData();
    }
}
</script>

<style scoped lang="scss">
  .table-data .el-table{
      -webkit-text-size-adjust: none;
  }
</style>


// WEBPACK FOOTER //
// list.vue?e8b7423a